// The shared Hub addresses have no company subdomain — a customer's Hub lives on
// `<slug>.hub.flair.hr`. Match them exactly (not a `hub.*` heuristic) so a tenant
// whose slug is literally "hub" (hub.hub.flair.hr) still gets the normal flow.
// localhost, CloudFront previews, and any real customer subdomain are not in the
// list, so they keep the normal login.
const SHARED_HUB_DOMAINS = ['hub.flair.hr', 'hub.dev.flair.hr'];

export const isSharedHubDomain = (): boolean =>
  SHARED_HUB_DOMAINS.includes(window.location.hostname);
